import Vue from 'vue'
// eslint-disable-next-line import/no-named-as-default
import BootstrapVue from 'bootstrap-vue'

Vue.use(BootstrapVue)
